import React from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import { parseNestiFyzExport } from "../nestifyz/parseExport";

import "filepond/dist/filepond.min.css";

registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginFileValidateSize);

/**
 * @param {object} props
 * @param {() => void} props.onFailure
 * @param {(f: {name: string, export: import("../nestifyz/parseExport").NestiFyzExport}) => void} props.onSuccess
 */
export const UploadNestiFyzMigrationFile = ({ onSuccess, onFailure }) => {
  const process = (_fieldName, file, _metadata, load, error, _progress, abort) => {
    const reader = new FileReader();

    reader.addEventListener("load", async (e) => {
      if (!e.target || !e.target.result) {
        error("Could not read file");
        onFailure();
        return;
      }

      try {
        const NestiFyzExport = await parseNestiFyzExport(/** @type {ArrayBuffer} */ (e.target.result));
        onSuccess({ name: file.name, export: NestiFyzExport });
        load(file.name);
      } catch {
        error("Could not parse file");
        onFailure();
      }
    });

    reader.addEventListener("error", () => {
      error("Could not read file");
      onFailure();
    });

    reader.readAsArrayBuffer(file);

    return {
      abort: () => {
        reader.abort();
        abort();
      },
    };
  };

  return (
    <FilePond
      allowMultiple={false}
      allowReplace={false}
      allowRevert={false}
      allowProcess={false}
      credits={false}
      instantUpload={true}
      maxFiles={1}
      acceptedFileTypes={["application/zip", "application/x-zip-compressed"]}
      labelIdle={'Drag & Drop your NestiFyz export file or <span class="filepond--label-action"> Browse </span>'}
      maxFileSize="200MB"
      server={{
        process,
      }}
    />
  );
};
